import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { Close, Check } from '@mui/icons-material';

const FinancialProductWarrantiesTableRow = ({ canWrite, warranty, onEdit, onDelete }) => {
  const [t] = useTranslation();

  return (
    <TableRow>
      
      <TableCell>{warranty.warrantyTypeName}</TableCell>
      <TableCell>{warranty.quantity}</TableCell>
      <TableCell>{warranty.quantityTypeName}</TableCell>
      <TableCell>
        <>{(warranty.mandatory) === true ? <Check color='success' /> : <Close />}</>
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='edit'
          fontSize='medium'
          color='transparent'
          tooltip={t('FinancialProduct.Edit')}
          onClick={onEdit(warranty.leasingFinancialProductXWarrantyId)}
        />
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('FinancialProduct.Delete')}
          onClick={onDelete(warranty.leasingFinancialProductXWarrantyId)}
          disabled={!canWrite}
        />
      </TableCell>
    </TableRow>
  );
};

FinancialProductWarrantiesTableRow.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  warranty: PropTypes.object,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default FinancialProductWarrantiesTableRow;
